import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

type sizeProps = "xs" | "sm" | "md" | "lg" | "xl";

const useResponsive = (size: sizeProps, noSsr = false, initialValue = true): boolean => {
  const theme = useTheme();
  const result = useMediaQuery(theme.breakpoints.down(size), {
    noSsr,
    defaultMatches: initialValue,
  });

  return result;
};

export default useResponsive;
